import { render, staticRenderFns } from "./GoodsSwimWearAdminView2.vue?vue&type=template&id=f4c81be8&"
import script from "./GoodsSwimWearAdminView2.vue?vue&type=script&lang=js&"
export * from "./GoodsSwimWearAdminView2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSwimWearAdminView2.vue?vue&type=style&index=0&id=f4c81be8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports